<template>
  <div class="emergencyTicket w-100 h-100">
    <div
      v-if="!showEmergencyOptions"
      class="d-flex flex-column"
    >
      <h3 class="mt-5 mb-5 mx-auto">Is the issue you are experiencing an emergency?</h3>
      <v-btn
        style="width: 100%; height: 100px"
        class="mb-3"
        elevation="10"
        fab
        rounded
        x-large
        @click="isEmergency(true)"
      >
        <div class="d-flex flex-column align-center">
          <v-icon>warning</v-icon><span>Yes, this is an emergency</span>
        </div></v-btn
      >
      <v-btn
        style="width: 100%; height: 100px"
        class="mb-3"
        elevation="10"
        fab
        rounded
        x-large
        @click="isEmergency(false)"
      >
        <div class="d-flex flex-column align-center">
          <v-icon>mdi-check-circle-outline</v-icon><span>No, submit a support ticket</span>
        </div></v-btn
      >
    </div>
    <div
      v-if="showEmergencyOptions"
      class="d-flex flex-column"
    >
      <div class="d-flex justify-space-around align-end">
        <component
          v-for="channel in facilityChannels"
          :key="channel.id"
          :is="channelComponentType(channel)"
          :channel="channel"
        />
        <h2
          class="w-100 text-center"
          style="margin-top: 100px"
          v-if="!facilityChannels.length"
        >
          Please contact support directly.
        </h2>
      </div>
      <v-btn
        style="width: 100%; height: 100px; margin-top: 100px"
        elevation="10"
        fab
        rounded
        x-large
        @click="isEmergency(false)"
      >
        <div class="d-flex flex-column align-center">
          <v-icon>mdi-check-circle-outline</v-icon><span>Submit a support ticket</span>
        </div></v-btn
      >
    </div>
  </div>
</template>

<script>
import TeamsButton from '@/components/repairTickets/EmergencyTickets/TeamsButton.vue';
import WhatsAppButton from '@/components/repairTickets/EmergencyTickets/WhatsAppButton.vue';
import Trimaster from '@/plugins/servers/trimaster';
import { mapGetters } from 'vuex';
export default {
  name: 'EmergencyTicket',
  components: {
    WhatsAppButton,
    TeamsButton,
  },
  data() {
    return {
      showEmergencyOptions: false,
      facilityChannels: [],
    };
  },
  computed: {
    ...mapGetters(['getUser']),
  },
  beforeMount() {
    this.loadChannels();
  },
  methods: {
    async loadChannels() {
      let [channels, err] = await Trimaster.get('facilityChannels', this.getUser.apitoken, {
        filter: {
          where: {
            facility_id: this.getUser.facility_id,
          },
        },
      });
      this.facilityChannels = channels;
    },
    channelComponentType(channel) {
      return `${channel.type}Button`;
    },
    isEmergency(emergency) {
      if (emergency) {
        this.showEmergencyOptions = true;
      } else {
        this.$emit('next');
      }
    },
  },
};
</script>
